import axios from 'axios';
import { tokenUtils } from '../utils/tokenUtils';

const API_URL = process.env.REACT_APP_API_URL + '/Users';
const API_URL_get = process.env.REACT_APP_API_URL + '/User';

function getAuthHeaders() {
  const token = tokenUtils.get();
  if (!token) throw new Error('No se encontró token de autenticación');
  return {
    Authorization: `Bearer ${token}`,
  };
}

const getUsers = async () => {
  try {
    const response = await axios.get(API_URL_get, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error al obtener usuarios:', error);
    throw error;
  }
};

const getUser = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error(`Error al obtener usuario con id ${id}:`, error);
    throw error;
  }
};

const saveUserRegister = async (id, payload) => {
  try {
    const response = await axios.put(`${API_URL}/${id}`, payload, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error(`Error al guardar registro del usuario con id ${id}:`, error);
    throw error;
  }
};



const UsersService = {
  getUsers,
  getUser,
  saveUserRegister,
};

export default UsersService;
